import { render, staticRenderFns } from "./ChatWhatsApp.vue?vue&type=template&id=1ba70147&"
import script from "./ChatWhatsApp.vue?vue&type=script&lang=js&"
export * from "./ChatWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports